import { render, staticRenderFns } from "./to-top.vue?vue&type=template&id=75f35b83&scoped=true&"
import script from "./to-top.vue?vue&type=script&lang=js&"
export * from "./to-top.vue?vue&type=script&lang=js&"
import style0 from "./to-top.vue?vue&type=style&index=0&id=75f35b83&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f35b83",
  null
  
)

export default component.exports